
import { i18nText } from '@/locales';

import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import {mixins} from 'vue-class-component';
import {SimpleProxyForm} from '@/UI/components/Helpers/SimpleProxyForm';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {Button, Menu, List, Select, Transfer, Tree} from 'ant-design-vue';
import {SalonsMix} from '@/UI/mixins/SalonsMix';
import {ServicesCategoryStore} from '@/store/modules/ServicesCategory';
import {ProductsCategoriesStore} from '@/store/modules/Warehouse/ProductsCategories';
import {LoyaltySubscriptionTypeStore} from '@/store/modules/Loyalty/Subscription/LoyaltySubscriptionType';
import {checkUserRole} from '@/router/Lib/helper';
import {SearchData} from '@/UI/Decorators/decorator';
import {SalonForm} from "@/UI/pages/salons/lib/SalonForm";
import {ProxyTableData} from '@/UI/components/Helpers/ProxyTableData';
import {SalonsStore} from '@/store/modules/Salons';

@Component({
  components: {
    BaseDataForm,
    'a-button': Button,
    'a-menu-item': Menu.Item,
    'a-list-item': List.Item,
    'a-list-item-meta': List.Item.Meta,
    'a-select': Select,
    'a-select-option': Select.Option,
    'a-transfer': Transfer,
    'a-tree': Tree,
  },
})

export default class StudioTransfer extends mixins(
    SimpleProxyForm,
    SalonsMix,
    ProxyTableData
) {
  @Prop() form!: SalonForm;
  target_keys: any = []
  selected_keys: any = []
  target_selected_keys: any = []
  keysToDelete: any = []
  data_source: any = []
  service_cat: any = []
  products_cat: any = []
  loyalty_subs_cat: any = []
  tree_data: any = []
  target_tree_data: any = []
  role = checkUserRole()

  @SearchData
  hSearch(source: string, value: {}) {
  }

  searchSalons(val: string) {
    this.hSearch('salons', {name: val})
  }

  async getData(): Promise<void> {
    await this.fetchModule([
      {s: 'servicesCategory', p: {filter: {salon_id: this.form.transfer.salon_id}}},
      {s: 'ProductsCategories', p: {filter: {salon_id: this.form.transfer.salon_id}, options: {'products': 1}}},
      {s: 'loyaltySubscriptionType', p: {filter: {salon_id: this.form.transfer.salon_id}}}
    ])
    this.service_cat = this.servicesCategory
    this.products_cat = this.ProductsCategories
    this.loyalty_subs_cat = this.loyaltySubscriptionType
  }

  fillTree(): void {
    let currentIndex = 0;
    if (this.service_cat && this.service_cat.length) {
      for (let i of this.service_cat) {
        this.tree_data[currentIndex].children.push({
          title: i.name,
          key: 'service-category-' + i.id.toString(),
          children: i.services ? i.services.flatMap((x: any) => [{
            title: x.name,
            key: 'service-' + i.id.toString() + '-' + x.id.toString()
          }]) : []
        })
      }
      currentIndex++;
    } else {
      this.tree_data = this.tree_data.filter((elem: Record<any, any>) => {
        return elem.key !== 'service-all'
      });
    }
    if (this.products_cat && this.products_cat.length) {
      for (let i of this.products_cat) {
        this.tree_data[currentIndex].children.push({
          title: i.name,
          key: 'product-category-' + i.id.toString(),
          children: i.children ? i.children.flatMap((x: any) => [{
            title: x.name,
            key: 'product-' + i.id.toString() + '-' + x.id.toString()
          }]) : []
        })
      }
      currentIndex++;
    } else {
      this.tree_data = this.tree_data.filter((elem: Record<any, any>) => {
        return elem.key !== 'product-all'
      });
    }
    if (this.loyalty_subs_cat && this.loyalty_subs_cat.length) {
      for (let i of this.loyalty_subs_cat) {
        this.tree_data[currentIndex].children.push({
          title: i.name,
          key: 'loyalty-category-' + i.id.toString(),
          children: i.children ? i.children.flatMap((x: any) => [{
            title: x.name,
            key: 'loyalty-' + i.id.toString() + '-' + x.id.toString()
          }]) : []
        })
      }
    } else {
      this.tree_data = this.tree_data.filter((elem: Record<any, any>) => {
        return elem.key !== 'loyalty-all'
      });
    }
  }

  async selectSalonGetData(): Promise<void> {
    try {
      this.formReady = false
      await this.getData()
      this.tree_data = []
      //this.selected_keys = []
      this.target_tree_data = []
      this.target_selected_keys = []
      this.keysToDelete = []
      this.target_keys = []
      this.data_source = []
      this.tree_data = [
        {title: i18nText("Услуги"), key: 'service-all', children: []},
        {title: i18nText("Товары"), key: 'product-all', children: []},
        {title: i18nText("Абонементы"), key: 'loyalty-all', children: []}
      ]
      this.fillTree();
      if (Vue.router.currentRoute.params['id']) {
        if (
            this.loyalty_subs_cat.length !== 0 ||
            this.products_cat.length !== 0 ||
            this.service_cat !== 0
        ) {
          this.getTransfer()
        }
      }

      this.fillDataSource(this.tree_data);

      //this.data_source = this.tree_data;
    } catch (e) {
      console.error(e)
    } finally {
      this.formReady = true
    }
  }

  fillDataSource(data: any): void {
    data.forEach((item: any) => {
      this.data_source.push(item);

      if (item.children) {
        this.fillDataSource(item.children);
      }
    });
  }

  onChecked(_: any, e: any, checkedKeys: any, itemSelectAll: any): void {
    //const { eventKey } = e.node;
    //itemSelect(eventKey, !(checkedKeys.indexOf(eventKey) !== -1));
    try {
      if (e.event == 'check') {
        itemSelectAll(checkedKeys, false);
        itemSelectAll(this.selected_keys, true);
      }
    } catch (e) {
      console.error(e);
    }
  }

  onCheckedTarget(_: any, e: any, checkedKeys: any, itemSelectAll: any): void {
    try {
      if (e.event == 'check') {
        itemSelectAll(checkedKeys, false);
        itemSelectAll(this.target_selected_keys, true);
      }
    } catch (e) {
      console.error(e);
    }
  }

  handleTreeData(data: any): void {
    data.forEach((item: any) => {
      item['disabled'] = this.target_keys.includes(item.key);

      if (item.children) {
        this.handleTreeData(item.children);
      }
    });
  }

  collectRequestData(): void {
    // @ts-ignore
    this.form.transfer.services = {all: false, category: [], id: []}
    // @ts-ignore
    this.form.transfer.products = {all: false, category: [], id: []}
    // @ts-ignore
    this.form.transfer.loyalty = {all: false, category: [], id: []}

    this.target_keys.forEach((item: any) => {
      let strParts = item.split('-');
      if (strParts[0] === 'service') {
        if (strParts[1] === 'all') {
          this.form.transfer.services.all = true as any;
        } else if (strParts[1] === 'category') {
          this.form.transfer.services.category.push(strParts[2]);
        } else {
          this.form.transfer.services.id.push(strParts[2]);
        }
      } else if (strParts[0] === 'product') {
        if (strParts[1] === 'all') {
          this.form.transfer.products.all = true as any;
        } else if (strParts[1] === 'category') {
          this.form.transfer.products.category.push(strParts[2]);
        } else {
          this.form.transfer.products.id.push(strParts[2]);
        }
      } else if (strParts[0] === 'loyalty') {
        if (strParts[1] === 'all') {
          this.form.transfer.loyalty.all = true as any;
        } else if (strParts[1] === 'category') {
          this.form.transfer.loyalty.category.push(strParts[2]);
        } else {
          this.form.transfer.loyalty.id.push(strParts[2]);
        }
      }
    })
  }

  handleTargetTreeData(data: any): Array<Record<any, any>> {
    let returnData: Record<any, any>[] = [];
    if (this.target_keys.length) {
      let newData : Record<any, any>[] = Array.from(data);
      newData.map(item => {
        // @ts-ignore
        let isSelected = this.target_keys.includes(item.key);

        let newItem : Record<any, any> = {
          'disabled': false,
          'key': item['key'],
          'title': item['title'],
          'children': undefined
        };
        if (item.children) {
          newItem['children'] = this.handleTargetTreeData(item.children);
        }

        if (isSelected) {
          newItem['disabled'] = false;
          if (!newItem['key'].includes('_selected')) {
            newItem['key'] += '_selected';
          }
          returnData.push(newItem);
        } else if (newItem.children && newItem.children.length > 0) {
          returnData.push(newItem);
        }

      });
    }
    return returnData;
  }

  cutOffUnnecessaryElements(keys: any): any {
    let targetKeys: Array<Record<any, any>> = Array.from(keys);
    // @ts-ignore
    let newTargetKeys = [];

    // Если выбрано "Все элементы", то удаляются все дочерние
    for (let i = 0; i < targetKeys.length; i++) {
      if (
          (!this.keysToDelete.includes('service-all') && targetKeys[i].includes('service')) ||
          (!this.keysToDelete.includes('product-all') && targetKeys[i].includes('product')) ||
          (!this.keysToDelete.includes('loyalty-all') && targetKeys[i].includes('loyalty'))
      ) {
        newTargetKeys.push(targetKeys[i]);
      }
    }

    // Если выбрано категория элемента, то удаляются все дочерние элементы
    if (newTargetKeys.length) {
      for (let i = 0; i < this.keysToDelete.length; i++) {
        let isCategory = this.keysToDelete[i].includes('category');

        if (isCategory) {
          let splitedData = this.keysToDelete[i].split('-');
          let categoryID = splitedData.length > 1 ? splitedData[2] : 0;
          if (categoryID) {
            newTargetKeys = newTargetKeys.filter(
                (element) => {
                  // @ts-ignore
                  return !element.includes(splitedData[0] + '-' + categoryID)
                }
            );
          }
        }
      }
    }
    // @ts-ignore
    return newTargetKeys;
  }

  collectChildrenElements(data: any, checked: boolean = false): void {
    data.forEach((item: any) => {
      let isChecked = this.target_keys.includes(item.key) && !this.keysToDelete.includes(item.key) || checked;
      let isCategoryNeedDelete = this.keysToDelete.includes(item.key);

      if (isChecked && !this.target_keys.includes(item.key) && !this.keysToDelete.includes(item.key)) {
        this.target_keys.push(item.key)
      }

      if (item.children && !isCategoryNeedDelete) {
        this.collectChildrenElements(item.children, isChecked);
      }
    });
  }

  transferKeys(keys: any, direction: any, moveKeys: any): void {
    try {
      moveKeys.forEach((item: any) => {
        let strParts = item.split('_');
        if (strParts.length > 1 && strParts[strParts.length - 1] === 'selected') {
          keys.splice(keys.indexOf(strParts[0]), 1);
          this.target_selected_keys.splice(this.target_selected_keys.indexOf(item), 1);
          this.keysToDelete.push(strParts[0]);
        }

        let splitedData = strParts[0].split('-');
        let isCategory = splitedData['1'] === 'category';
        let isParent = splitedData['1'] === 'all';

        if (direction === 'right') {
          this.keysToDelete = this.keysToDelete.filter(
              // @ts-ignore
              (element) => {
                return element !== strParts[0] &&
                    ((isParent && !element.includes(splitedData[0]))
                        ||
                        (isCategory && !element.includes(splitedData[0] + '-' + splitedData[2])));
              }
          )
        }
      });

      this.target_keys = this.cutOffUnnecessaryElements(keys);

      // Удаляются категории из keys, если у категории не осталось дочерних элементов
      if (direction === 'left') {
        this.target_keys.forEach((item: any) => {
          let splitedData = item.split('-');
          let categoryID = splitedData.length > 1 ? splitedData[2] : 0;
          let isCategory = splitedData['1'] === 'category' && (splitedData[0] === 'service' || splitedData[0] === 'product');
          let isParent = splitedData['1'] === 'all';
          let newTargetKeys = [];
          // смотрим только род категории. Единичные элементы не нужно смотреть
          if (isParent || isCategory) {
            if (isParent) {
              newTargetKeys = this.target_keys.filter((element: string | any[]) => {
                return element !== splitedData[0] + '-all' && element.includes(splitedData[0]);
              })
            } else if (isCategory && (splitedData[0] === 'service' || splitedData[0] === 'product')) {

              newTargetKeys = this.target_keys.filter(
                  (element: string | string[]) => {
                    return element.includes(splitedData[0] + '-' + categoryID)
                  }
              );
            }

            if (!newTargetKeys.length) {
              this.target_keys.splice(this.target_keys.indexOf(item), 1);
            }
          }
        });
      }

      this.collectChildrenElements(this.tree_data);
      this.handleTreeData(this.tree_data);
      this.target_tree_data = this.handleTargetTreeData(this.tree_data);

      if (!this.target_keys.length) {
        this.keysToDelete = [];
      }

      this.collectRequestData();
      this.selected_keys = Array.from(this.target_keys);

    } catch (e) {
      console.error(e);
    }
  }

  // непонятно, зачем это нужно..
  // sortData(): void {
  //     for(let i of this.data_source) {
  //         if (i.key === 'service-all') {
  //             i.children.forEach((x: any) => {
  //                 this.form.transfer.services.all = true as any
  //                 this.form.transfer.services.category.push(x.key)
  //                 x.children.forEach((p: any) => {
  //                     this.form.transfer.services.id.push(p.key)
  //                 })
  //             })
  //         }
  //         if (i.key === 'product-all') {
  //             i.children.forEach((x: any) => {
  //                 this.form.transfer.products.all = true as any
  //                 this.form.transfer.products.category.push(x.key)
  //                 x.children.forEach((p: any) => {
  //                     this.form.transfer.products.id.push(p.key)
  //                 })
  //             })
  //         }
  //         if (i.key === 'loyalty-all') {
  //             i.children.forEach((x: any) => {
  //                 this.form.transfer.loyalty.all = true as any
  //                 this.form.transfer.loyalty.category.push(x.key)
  //                 x.children.forEach((p: any) => {
  //                     this.form.transfer.loyalty.id.push(p.key)
  //                 })
  //             })
  //         }
  //     }
  //     if (this.mod_transfer === false) {
  //         // ПЕРЕДЕЛАТЬ
  //         this.form.transfer.services = {all: '', category: [], id: []}
  //         this.form.transfer.products = {all: '', category: [], id: []}
  //         this.form.transfer.loyalty = {all: '', category: [], id: []}
  //     }
  // }

  getTransfer(): void {
    for (let i of this.tree_data) {
      this.data_source.push({title: i.title, key: i.key})
      this.target_keys.push(i.key)
      //this.selected_keys.push(i.key)
      for (let l of i.children) {
        this.target_keys.push(l.key)
        this.data_source.push({title: l.title, key: l.key})
        //this.selected_keys.push(l.key)
        if (i.key === 'service-all') {
          this.form.transfer.services.all = true as any;
          this.form.transfer.services.category.push(l.key)
        }
        if (i.key === 'product-all') {
          this.form.transfer.products.all = true as any;
          this.form.transfer.products.category.push(l.key)
        }
        if (i.key === 'loyalty-all') {
          this.form.transfer.loyalty.all = true as any;
          this.form.transfer.loyalty.category.push(l.key)
        }
        for (let j of l.children) {
          this.target_keys.push(j.key)
          this.data_source.push({title: j.title, key: j.key})
          //this.selected_keys.push(j.key)
          if (i.key === 'service-all') this.form.transfer.services.id.push(j.key)
          if (i.key === 'service-all') this.form.transfer.products.id.push(j.key)
          if (i.key === 'loyalty-all') this.form.transfer.loyalty.id.push(j.key)
        }
      }
    }
    //this.data_source = [two, three, one]
  }

  async created(): Promise<void> {
    this.formReady = false
    try {
      if (this.role === 'admin') {
        await this.fetchModule([
          {s: 'salons', p: {limit: this.AppPageParams.pageSize}}
        ])
      }
      if (Vue.router.currentRoute.params['id']) {
        this.form.transfer.salon_id = Number(Vue.router.currentRoute.params['id'])
        await this.selectSalonGetData()
      }
    } catch (e) {
      console.error(e)
    } finally {
      this.formReady = true;
    }
  }

  get salons(): any {
    return SalonsStore.salons?.data
  }

  get ProductsCategories(): any {
    return ProductsCategoriesStore.productsCategories
  }

  get loyaltySubscriptionType(): any {
    return LoyaltySubscriptionTypeStore.loyaltySubscriptionTypes?.data
  }

  get servicesCategory(): any {
    return ServicesCategoryStore.serviceCategory?.data
  }

}
